import ApplicationAdapter from "./application";

export default class InviteAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.baseUri()}/invite/show?invitecode=${id}`;
  }
}
